import { render, staticRenderFns } from "./CellRendererMATERIALS.vue?vue&type=template&id=8da0a3b8&scoped=true&"
import script from "./CellRendererMATERIALS.vue?vue&type=script&lang=js&"
export * from "./CellRendererMATERIALS.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererMATERIALS.vue?vue&type=style&index=0&id=8da0a3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0a3b8",
  null
  
)

export default component.exports